import { ref, computed } from 'vue'
import { useAuth } from './auth'
import { useViews } from './views'

// 模块级别的共享状态（单例）
const isMobileMenuOpen = ref(false)

export function useMobileMenu() {
  const { user } = useAuth()
  const { currentView } = useViews()

  const showSidebar = computed(() => {
    return user.value && currentView.value !== 'HomePage'
  })

  const showMobileMenuButton = computed(() => {
    return showSidebar.value && currentView.value !== 'HomePage'
  })

  const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
  }

  const closeMobileMenu = () => {
    isMobileMenuOpen.value = false
  }

  return {
    isMobileMenuOpen,
    showSidebar,
    showMobileMenuButton,
    toggleMobileMenu,
    closeMobileMenu
  }
}
